// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.staff_management {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.staff_management .table_row {
  cursor: pointer;
}
.staff_management .table_row:last-child td, .staff_management .table_row:last-child th {
  border: 0;
}
.staff_management .table_row:hover {
  background-color: #bf1a1a;
}
.staff_management .conversation_form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 80vw;
  margin: auto;
}
@media (max-width: 690px) {
  .staff_management .conversation_form {
    width: 90vw;
  }
}
.staff_management .conversation_form label {
  margin: 1% 0;
}
.staff_management .conversation_form label .label {
  color: #bf1a1a;
}
.staff_management .conversation_form label #alert {
  display: none;
  color: #bf1a1a;
  font-weight: 800;
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
.staff_management .conversation_form select {
  width: 80%;
}
.staff_management .conversation_form strong {
  margin: 1% 0 0 0;
}
.staff_management .conversation_form textarea {
  min-width: 50vw;
  max-width: 80vw;
  min-height: 15vh;
  white-space: pre-wrap;
}
@media (max-width: 690px) {
  .staff_management .conversation_form textarea {
    min-width: 80vw;
  }
}
.staff_management .conversation_form input[type=date] {
  margin-bottom: 1%;
}
.staff_management .conversation_form input[type=text] {
  margin-bottom: 1%;
  width: 50%;
}

.manager_signature .signature {
  font-family: "Pacifico", cursive;
  font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/staffManagement/staffManagement.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI;IAEI,kCAAA;EAFN;EAKE;IAEI,iCAAA;EAJN;EAOE;IAGI,kCAAA;EAPN;EAUE;IAEI,iCAAA;EATN;AACF;AAaA;ECOI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EDRA,WAAA;AARJ;AASI;EACI,eAAA;AAPR;AAQQ;EACI,SAAA;AANZ;AAQQ;EACI,yBCnCJ;AD6BR;AASI;ECZA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EDWI,WAAA;EACA,YAAA;AAJR;AAKQ;EAJJ;IAKQ,WAAA;EAFV;AACF;AAGQ;EACI,YAAA;AADZ;AAEY;EACI,cChDR;ADgDR;AAEY;EACI,aAAA;EACA,cCpDR;EDqDQ,gBAAA;EACA,gEAAA;AAAhB;AAGQ;EACI,UAAA;AADZ;AAIQ;EACI,gBAAA;AAFZ;AAIQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAFZ;AAGY;EALJ;IAMQ,eAAA;EAAd;AACF;AAEQ;EACI,iBAAA;AAAZ;AAEQ;EACI,iBAAA;EACA,UAAA;AAAZ;;AAMI;EACI,gCAAA;EACA,eAAA;AAHR","sourcesContent":["@import '../styles/variables.scss';\n\n@keyframes shake {\n    10%,\n    90% {\n        transform: translate3d(-1px, 0, 0);\n    }\n\n    20%,\n    80% {\n        transform: translate3d(2px, 0, 0);\n    }\n\n    30%,\n    50%,\n    70% {\n        transform: translate3d(-4px, 0, 0);\n    }\n\n    40%,\n    60% {\n        transform: translate3d(4px, 0, 0);\n    }\n}\n\n\n.staff_management{\n    @include columnStartCenter;\n    width: 100%;\n    .table_row{\n        cursor: pointer;\n        &:last-child td, &:last-child th{\n            border: 0\n        }\n        &:hover{\n            background-color: $rtRed;\n        }\n    }\n    .conversation_form{\n        @include columnStart;\n        width: 80vw;\n        margin: auto;\n        @media (max-width: $mobile){\n            width: 90vw;\n        }\n        label{\n            margin: 1% 0;\n            .label{\n                color: $rtRed;\n            }\n            #alert{\n                display: none;\n                color: $rtRed;\n                font-weight: 800;\n                animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;    \n            }\n        }\n        select{\n            width: 80%;\n    \n        }\n        strong{\n            margin: 1% 0 0 0;\n        }\n        textarea{\n            min-width: 50vw;\n            max-width:80vw;\n            min-height: 15vh;\n            white-space: pre-wrap;\n            @media(max-width: $mobile){\n                min-width: 80vw;\n            }\n        }\n        input[type=date]{\n            margin-bottom: 1%;\n        }\n        input[type=text]{\n            margin-bottom: 1%;\n            width: 50%;\n        }\n    }\n}\n\n.manager_signature{\n    .signature{\n        font-family: 'Pacifico', cursive; \n        font-size: 2rem;\n    }\n}","$rtRed: #bf1a1a;\n$rtBlack: #1d1d1d;\n$warning: #ff8808;\n$success: #00a74f;\n\n//Brand Colours\n$hr_dark_blue: #012748;\n$hr_blue: #0f4e6f;\n$hr_gold: #b66d2d;\n$hr_orange: #fe9816;\n$hr_yellow: #fede8c;\n\n//mobile breaks\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnEnd {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin shadow {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
